import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ClipboardCopy } from '../../clipboard-copy.service';
import { InputComponent } from '../../forms/input/input.component';

@Component({
  selector: 'rt-copy-input',
  styleUrls: ['./copy-input.component.less'],
  templateUrl: 'copy-input.component.html',
})
export class CopyInputComponent {
  @Input() public value: string;
  @Input() public hasOpenInNewTabButton: boolean = false;
  @Input() public hasCopyButton: boolean = true;
  @Output() public copied: EventEmitter<void> = new EventEmitter<void>();

  constructor(private clipboardCopy: ClipboardCopy) {}

  public copy(element: InputComponent): void {
    this.clipboardCopy.fromHtmlElement(element.input.nativeElement);
    this.copied.emit();
  }
}
